
import Navbar from "../navbar/Navbar";
import { UserProfile } from "../user/components/UserProfile";
function UserprofilePage() {
    return (
        <div>
        <Navbar>
        <UserProfile></UserProfile>
      </Navbar>
       </div>
    );
}

export default UserprofilePage;

